import * as React from "react";
import { PerformanceClasses } from "../../../../schema/types/volumeSet/entity";
import { FormItem } from "../../../../components/antd/form/FormItem";
import { FormItemValue } from "../../../../components/antd/form/FormItemValue";
import { FormLabel } from "../../../../components/antd/form/FormLabel";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";

export const PerformanceClassReadonly: React.FC = () => {
  const performanceClass = useCpFormValue(`performanceClass`);
  const fileSystemType = useCpFormValue(`fileSystemType`);

  const performanceClassObject = PerformanceClasses.find((pc) => pc.name === performanceClass);

  if (fileSystemType === "shared") {
    return null;
  }
  return (
    <FormItem lastItem>
      <FormLabel>Performance Class</FormLabel>
      <FormItemValue>{performanceClassObject?.readableName}</FormItemValue>
      <div className="flex gap-4 mt-4 pl-4 border-l-2">
        <div>
          <FormLabel>Min Capacity</FormLabel>
          <div>{performanceClassObject?.minCapacity} GB</div>
        </div>
        <div>
          <FormLabel>Max Capacity</FormLabel>
          <div>{performanceClassObject?.maxCapacity} GB</div>
        </div>
      </div>
    </FormItem>
  );
};
